import { render, staticRenderFns } from "./GroupEscortsWidget.vue?vue&type=template&id=32dd71a8&scoped=true"
import script from "./GroupEscortsWidget.vue?vue&type=script&lang=js"
export * from "./GroupEscortsWidget.vue?vue&type=script&lang=js"
import style0 from "./GroupEscortsWidget.vue?vue&type=style&index=0&id=32dd71a8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dd71a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32dd71a8')) {
      api.createRecord('32dd71a8', component.options)
    } else {
      api.reload('32dd71a8', component.options)
    }
    module.hot.accept("./GroupEscortsWidget.vue?vue&type=template&id=32dd71a8&scoped=true", function () {
      api.rerender('32dd71a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/GroupEscortsWidget.vue"
export default component.exports